<script lang="ts" setup>
import { storeToRefs } from 'pinia'

import SpecialistCardFull from '~/components/cards/SpecialistCardFull.vue'
import BasicButton from '~/components/form-elements/BasicButton.vue'
import ViewAllButton from '~/components/form-elements/ViewAllButton.vue'
import AuthScope from '~/enums/auth-scope'
import Page from '~/enums/page'
import { useSpecialistsStore } from '~/store/specialists'

withDefaults(
  defineProps<{
    subtitle?: string | null
  }>(),
  { subtitle: 'Каталог специалистов' }
)

const partnerPath = Page.Partner
const specialistsPath = Page.Specialists

const route = useRoute()
const router = useRouter()

const specialistsStore = useSpecialistsStore()
const { getSpecialists } = storeToRefs(specialistsStore)

async function loadData (): Promise<void> {
  specialistsStore.page.number = 1
  await specialistsStore.fetchSpecialists(AuthScope.Client)
}

onMounted(async (): Promise<void> => {
  await loadData()
})
</script>

<template>
  <section v-if="getSpecialists.length">
    <div class="container">
      <Heading v-if="subtitle" element="h2" :path="specialistsPath" :title="subtitle" title-class="h1">
        <template #buttons>
          <ViewAllButton title="Все специалисты" @click="router.push(specialistsPath)" />
        </template>
      </Heading>
    </div>

    <Carousel>
      <div class="-ml-2 flex md:-ml-4">
        <div
          v-for="x in getSpecialists"
          :key="x.id"
          class="flex-[0_0_75%] cursor-pointer pl-2 md:flex-[0_0_33.333333%] md:pl-4"
        >
          <SpecialistCardFull :specialist-data="x" />
        </div>
      </div>
    </Carousel>

    <div v-if="route.path !== Page.Main" class="container mt-6">
      <BasicButton color="green" title="Стать специалистом" @click="router.push(partnerPath)" />
    </div>
  </section>
</template>
